/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Caption } from '../../../components/Text';
import InputWithLabel from '../../../components/InputWithLabel';
import { Race } from '../../../../apiServices/ListsService';
import ProfileModel, { ProfileData } from '../../../../models/ProfileModel';
import { CardSection } from '../../../components/card/Card';

interface ProfileRaceSelfIdentityProps {
  profileData: ProfileData;
  onChange(data: ProfileData, callback?): void;
  clearViewErrors(): void;
  phraseData: any;
  races: Race[];
}

class ProfileRaceSelfIdentity extends React.Component<ProfileRaceSelfIdentityProps, {}> {

  render() {
    const { profileData, phraseData, clearViewErrors } = this.props;
    const identity = profileData.race.identity || '';
    const greetingName = new ProfileModel(profileData).greetingName();

    return (
      <CardSection hasBorder>
        <form>
          <InputWithLabel
            value={identity}
            noForcedHeight
            onChange={(e) => { this.handleIdentityChange(e.target.value); }}
            onFocus={clearViewErrors}
            type="text"
            label={<FormattedMessage id={phraseData.identityLabel.id} values={{ string1: greetingName }}/>}
            name="identity"
            isClearable
            clearValue={() => { this.handleIdentityChange(''); }}
          >
            <Caption>
              <FormattedMessage id={phraseData.identityExample.id} />
            </Caption>
          </InputWithLabel>
        </form>
      </CardSection>
    );
  }

  handleIdentityChange = (identity) => {
    const { profileData, onChange } = this.props;

    onChange({
      ...profileData,
      race: {
        identity: identity || undefined,
        race_id: profileData.race.race_id,
      },
    });
  }
}

export default ProfileRaceSelfIdentity;
